import React, { useCallback, useEffect, useRef, useState } from 'react';
import { DropDownContainer, DropDownHook, Grid, Para, TextButton, Theme } from 'uie/components';
import { Calendar } from 'react-date-range';
import { CalandarIcon } from '../../icons';
import { Locale } from 'core/helpers/dateUtils';
import TimePicker from './TimePicker';
import moment from 'moment';

const { theme } = Theme;

const dateDisplayFormat = Locale.shortDateFormat.replace(/L/g, 'M');

interface IProps {
  selectedDate: Date;
  minDate: Date;
  maxDate: Date;
  onUpdateRange: (date: Date, dateString: string) => void;
  dateString: string;
}

const DateTimeDropdown: React.FC<IProps> = ({ selectedDate, ...props }) => {
  const [selectedRange, setSelectedRange] = useState<Date | undefined>(selectedDate);
  const [selectedTime, setSelectedTime] = useState<string | undefined>(undefined);
  const [formattedDate, setFormattedDate] = useState<string | undefined>(undefined);

  const [mountDropdown, setMountDropdown] = useState(false);
  const [isFirstInitalized, setIsFirstInitalized] = useState(true);

  setTimeout(() => {
    setMountDropdown(true);
  }, 200);

  const dropdownRef = useRef<HTMLDivElement>(null);
  const dateRangeRef = useRef<any>();

  const handleChangeTimeRange = (range: Date) => {
    setSelectedRange(range);
  };

  const handleApplyRange = () => {
    const formattedDate = moment(selectedRange).format('DD/MM/YYYY');
    const dateString = `${formattedDate} ${selectedTime}`;
    const isoDate = moment(dateString).format('DD/MM/YYYY hh:mm:ss A');
    setFormattedDate(isoDate);
    props.onUpdateRange(selectedRange as Date, dateString);
    closeDropdown();
  };

  const onCancel = () => {
    setSelectedRange(selectedDate);

    closeDropdown();
  };

  const closeDropdown = () => {
    if (dropdownRef.current) {
      dropdownRef.current?.focus();
      dropdownRef.current?.blur();
    }
  };

  useEffect(() => {
    // Scroll to bottom
    if (dateRangeRef.current && isFirstInitalized) {
      try {
        // Scrollable Element
        const calendar = dateRangeRef.current.dateRange.calendar.list.scrollParent;
        calendar.scrollIntoView({ behavior: 'smooth', block: 'end' });
      } catch (error) {
        console.log(error);
      }
    }
  }, [isFirstInitalized]);

  useEffect(() => {
    setSelectedRange(selectedDate);
  }, [selectedDate]);

  return (
    <Grid alignItems="center" style={{ paddingTop: 15 }}>
      <DropDownHook
        style={{ width: '100%' }}
        ref={dropdownRef}
        onClick={() => setIsFirstInitalized(true)}
      >
        <Grid
          style={{ width: '100%', justifyContent: 'space-between' }}
          className="analytics__time_range-para"
        >
          <Para fontSize={14} style={{ width: '100%' }}>
            {props.dateString ? (
              <>
                <span className="font-bold">
                  {moment(props.dateString, 'DD/MM/YYYY, hh:mm:ss A').format(
                    'DD/MM/YYYY, hh:mm:ss A',
                  )}{' '}
                </span>{' '}
              </>
            ) : (
              <span className="font-normal">
                <Para fontSize={15} color="#91A2B5">
                  {' '}
                  dd/mm/yyyy, hh:mm:ss --
                </Para>
              </span>
            )}
          </Para>
          <CalandarIcon />
        </Grid>

        <DropDownContainer offset={'-100px'} style={{ padding: '0' }}>
          {mountDropdown && (
            <Grid type="column">
              <Grid type="row">
                <Calendar
                  minDate={props.minDate || new Date()}
                  maxDate={props.maxDate || new Date()}
                  onChange={handleChangeTimeRange as any}
                  date={selectedRange}
                  dateDisplayFormat={dateDisplayFormat}
                />
                <TimePicker
                  setTime={val => {
                    setSelectedTime(val);
                  }}
                />
              </Grid>
              <Grid justifyContent="flex-end">
                <TextButton buttonType="ghost" style={{ margin: '12px' }} onClick={onCancel}>
                  <Para fontSize={14}>Cancel</Para>
                </TextButton>
                <TextButton
                  onClick={handleApplyRange}
                  style={{ margin: '12px', float: 'left', fontSize: '14px' }}
                  disabled={!selectedTime || selectedTime?.includes('undefined')}
                >
                  <Para fontSize={14} color={theme.shades.white}>
                    Apply Time Range
                  </Para>
                </TextButton>
              </Grid>
            </Grid>
          )}
        </DropDownContainer>
      </DropDownHook>
    </Grid>
  );
};

export default DateTimeDropdown;
